import React from "react";
import { Header, Footer } from "components";
import * as Styled from "./styles";

type Props = {
  children: React.ReactNode;
};

const Layout: React.FC<Props> = ({ children }) => {
  return (
    <Styled.Wrapper>
      <Header />
      <Styled.Main>{children}</Styled.Main>
      <Footer />
    </Styled.Wrapper>
  );
};

export default Layout;
